// Utility to transform markdown image references to use Google Drive URLs

/**
 * Transform markdown content to replace image src attributes with Google Drive URLs
 * Only handles: ./description-assets/filename.png
 * @param {string} markdownContent - The original markdown content
 * @param {Object} descriptionAssets - Object mapping filename to Google Drive file ID
 * @returns {string} - Transformed markdown content
 */
export const transformMarkdownImages = (markdownContent, descriptionAssets) => {
  if (
    !markdownContent ||
    !descriptionAssets ||
    Object.keys(descriptionAssets).length === 0
  ) {
    return markdownContent;
  }

  // Transform HTML img tags: <img src="./description-assets/filename.png" alt="description">
  return markdownContent.replace(
    /<img([^>]*)\ssrc=["']\.\/description-assets\/([^"']+)["']([^>]*)>/gi,
    (match, beforeSrc, filename, afterSrc) => {
      if (descriptionAssets[filename]) {
        const googleDriveUrl = `/.netlify/functions/image-proxy?fileId=${descriptionAssets[filename]}`;
        return `<img${beforeSrc} src="${googleDriveUrl}"${afterSrc}>`;
      }
      return match; // Return original if not found in assets
    }
  );
};
